

class BEM {
  /**
   * Pass in a `baseClass` string, and an array of variants, and this method
   * will return an array containing the baseClass along with elements for each
   * BEM variant.
   * The second argument (variant) can be either a single variant or a list of
   * variants.
   */
  classNames(baseClass, variant) {
    var result = [baseClass];

    if (!Array.isArray(variant)) {
      variant = [variant];
    }

    for (var i = 0; i < variant.length; i++) {
      var tmp = variant[i];

      if (tmp) {
        result.push(baseClass + '--' + tmp.toString());
      }
    }


    return result;
  }

  /**
   * performs the next logical step after `classNames`, combining the array of
   * class names into a space-separated string
   */
  classString(baseClass, variant) {
    return this.classNames(baseClass, variant).join(' ');
  }
}


var bem = new BEM();

export default bem;

